import { Injectable } from '@angular/core';
import { SwUpdate, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateHandler {

  constructor(private swUpdate: SwUpdate) {
    this.checkForUpdates();
  }

  private checkForUpdates() {
    this.swUpdate.versionUpdates.
      pipe(
        filter((evt: VersionEvent): evt is VersionReadyEvent => 
          evt.type === 'VERSION_READY'),
        map(evt => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        })))
        .subscribe(() => this.promptUser());
  }

  private promptUser(): void {
    this.swUpdate.activateUpdate().then(() => { 
      confirm('There is a new version available. Do want to load it?')
      document.location.reload()
    });
  }
}
